/** Render symbols and meanings supplied by the model registry. */
export interface MathSegment {
  math: boolean;
  content: string;
}

/** Split a display-name string into alternating plain-text / math segments. */
export function parseMathSegments(text: string): MathSegment[] {
  const segments: MathSegment[] = [];
  const regex = /\$([^$]+)\$/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ math: false, content: text.slice(lastIndex, match.index) });
    }
    segments.push({ math: true, content: match[1] });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    segments.push({ math: false, content: text.slice(lastIndex) });
  }
  return segments;
}
